import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { AI_CHAT_ACCOUNTING_SUBSCRIPTION_REPOSITORY } from '../../core';
import { AI_CHAT_ACCOUNTING_SUBSCRIPTION_API } from '../data-sources';
export var AIChatAccountingSubscriptionRepository = /*#__PURE__*/function () {
  function AIChatAccountingSubscriptionRepository(accountingSubscriptionApi) {
    _classCallCheck(this, AIChatAccountingSubscriptionRepository);

    this.accountingSubscriptionApi = accountingSubscriptionApi;
  }

  _createClass(AIChatAccountingSubscriptionRepository, [{
    key: "getCurrentSubscription",
    value: function () {
      var _getCurrentSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.accountingSubscriptionApi.getCurrentSubscription());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCurrentSubscription() {
        return _getCurrentSubscription.apply(this, arguments);
      }

      return getCurrentSubscription;
    }()
  }]);

  return AIChatAccountingSubscriptionRepository;
}();
export var aiChatAccountingSubscriptionRepositoryProvider = {
  provide: AI_CHAT_ACCOUNTING_SUBSCRIPTION_REPOSITORY,
  useFactory: function useFactory(accountingSubscriptionApi) {
    return new AIChatAccountingSubscriptionRepository(accountingSubscriptionApi);
  },
  inject: [AI_CHAT_ACCOUNTING_SUBSCRIPTION_API]
};